// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SurfaceDeletionStatusSchema = z.enum(['PENDING','RUNNING','FAILED'] as const);

export type SurfaceDeletionStatusType = `${z.infer<typeof SurfaceDeletionStatusSchema>}`

export default SurfaceDeletionStatusSchema;
